var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st-form-item",attrs:{"st-form-item-prop":_vm.prop,"required":_vm.required}},[_c('p',{class:`st-van-filed-label  ${(_vm.required ? 'st-required' : '')}`},[_vm._v(_vm._s(_vm.label))]),_vm._t("default"),_c('div',{staticClass:"st-err-msg err-hide"},[_vm._v("不能为空")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }